const translations = {
    accountSetup: 'Account Setup',
    accountSetupComplete: 'Complete',
    activeJobs: 'Active Work Orders',
    announcementEavision: 'New EAVISION integration is live!',
    announcementUpgradedUi: 'Welcome to our upgraded UI experience.',
    applicationMapItem: 'Application Map',
    canceled: 'Canceled',
    complete: 'Complete',
    completedTasks: 'Completed Tasks',
    completedTasksStatus: '{completed} of {total} ✓',
    daysLeftInTrial: '{days} days left in trial',
    discountCompletionDetail:
        "You've completed all {total} required tasks. Your discounted rate is locked in — annual for {price}.",
    discountUnlockedTitle: "You've unlocked your discount!",
    droneAddedItem: 'At least 1 drone added',
    expires: 'Expires {date}',
    flightLogItem: 'Flight Log Upload',
    flightsMonth: 'Flights This Month',
    greetingAfternoon: 'Good afternoon, {name}',
    greetingEvening: 'Good evening, {name}',
    greetingMorning: 'Good morning, {name}',
    humidity: 'Humidity',
    incentiveLockedCtaButton: 'Start Free Trial',
    incentiveLockedCtaButtonSubscribe: 'Start Subscription',
    incentiveLockedCtaSubtitle:
        'Start a 7-day Premier trial. Complete the Spray Season Challenge to get annual for {price}.',
    incentiveLockedCtaSubtitleSubscribe:
        'Start a Premier subscription to gain access to the Spray Season Challenge.',
    incentiveLockedCtaTitle: 'Unlock prizes & savings',
    incomplete: 'Incomplete',
    locked: 'Locked',
    mapView: 'Map',
    moreBefore: '{remaining} more before {date}',
    needsAttention: 'Notification Center',
    needsAttentionEmpty: 'No items need attention right now.',
    newWorkOrder: 'New Work Order',
    organizationDetailsItem: 'Organization details filled out',
    pending: 'Pending',
    precipitation: 'Precip',
    premierBadge: 'Premier',
    productUsageReportItem: 'Product Usage Report',
    progressRequired: '{completed} of {total} required',
    quickActionFlightLabel: 'Log Flight',
    quickActionFlightSublabel: 'Record data',
    quickActionProductUsageLabel: 'Product Usage',
    quickActionProductUsageSublabel: 'New report',
    quickActionReportLabel: 'FAA Report',
    quickActionReportSublabel: 'File report',
    quickActionWorkOrderLabel: 'Work Order',
    quickActionWorkOrderSublabel: 'New order',
    quickActions: 'Quick Actions',
    raffleChallengeSubtitle: 'Win prizes up to {amount}',
    raffleCompletionDetail:
        "You've completed all {total} required tasks this month. You're entered for prizes up to {amount}.",
    resetsInDays: 'Resets in {days} days',
    scheduleEmptyText: 'No work orders scheduled. Create a work order to get started.',
    scheduleMapEmptyText: 'No work orders scheduled this month with a location to display.',
    scheduled: 'Scheduled',
    spraySeasonChallengeSubtitle: 'Complete your trial — get annual for {price}',
    spraySeasonChallengeTitle: 'Spray Season Challenge',
    started: 'Started',
    todaysSchedule: "Today's Schedule",
    trialBadge: 'Trial',
    unlockUsageChallengeDetailBoth:
        'Fill out your organization details and add at least one drone to get started.',
    unlockUsageChallengeDetailDrone: 'Add at least one drone to get started.',
    unlockUsageChallengeDetailOrganization: 'Fill out your organization details to get started.',
    unlockUsageChallengeTitle: 'Complete Account Setup to unlock your usage challenge.',
    upcomingWorkOrders: 'Upcoming Work Orders',
    usageChallenge: 'Usage Challenge',
    usageChallengeStatus: '{completed} of {total}',
    viewPrizeDetails: 'View Prize Details →',
    weatherWindStatValue: '{speed} mph {direction}',
    wind: 'Wind',
    workOrderItem: 'Work Order',
    youreInTheRaffle: "You're in the raffle!"
};

export default translations;
